import { Funken } from './Bausteine'
import Countdown from './Countdown'
import Entschluesseln from './Entschluesseln'
import Wabenfeld from './Wabenfeld'
import { konferenz } from '@/data/inhalte'

/** Titel der Karte links, Termin mit Countdown und Anmeldung rechts (auf dem Handy darunter).
 *  Darunter wogt das Wabennetz der Karte (Wabenfeld). */
export default function Aufmacher() {
  return (
    <section id="top" className="verlauf-konferenz relative isolate overflow-hidden text-white">
      <Wabenfeld className="h-[64%]" />
      <Funken />
      <div className="huelle-breit grid min-h-[100svh] content-end gap-10 pb-12 pt-32 sm:pt-44 lg:grid-cols-[minmax(0,1.3fr)_minmax(0,1fr)] lg:content-center lg:items-end lg:gap-16 lg:pb-20">
        <div>
          <div className="flex flex-wrap items-center gap-2.5">
            <p className="inline-flex rounded-full border border-white/60 bg-konf-nacht/70 px-4 py-1.5 font-display text-[15px] font-bold">
              {konferenz.marke}
            </p>
            {/* klarstellen: Online-Event (Wunsch 06.10.2026) */}
            <p className="inline-flex items-center gap-2 rounded-full bg-konf-hell px-4 py-1.5 font-display text-[15px] font-bold text-konf-nacht">
              <span aria-hidden="true" className="on-air h-2 w-2 rounded-full bg-[#E5322D]" />
              {konferenz.format}
            </p>
          </div>
          <Entschluesseln zeilen={konferenz.titel} className="mt-6 text-[clamp(44px,7.4vw,108px)] [text-shadow:0_2px_30px_rgba(0,30,43,.25)]" />
          <p className="mt-6 max-w-[32ch] font-display text-[clamp(18px,1.8vw,24px)] font-bold leading-snug">
            {konferenz.unterzeile}
          </p>
        </div>

        <div className="rounded-[28px] border border-white/20 bg-konf-nacht/45 p-6 shadow-[0_30px_60px_rgba(0,19,28,.25)] backdrop-blur-md sm:p-8">
          <p className="font-display text-[clamp(30px,3.4vw,46px)] font-bold leading-[1.04] tracking-[-0.02em] text-konf-hell">
            {konferenz.datum},<br />{konferenz.uhrzeit}
          </p>
          <p className="mt-4 font-display text-[20px] font-bold leading-snug">{konferenz.ort}</p>
          <Countdown />
          <div className="mt-7 flex flex-wrap gap-3">
            <a href="#anmeldung" className="knopf knopf-haupt">Jetzt anmelden</a>
          </div>
        </div>
      </div>
    </section>
  )
}
